
import { PermissionsState } from '@/types/permissions';

/**
 * Cache configuration and constants
 */
export const CACHE_CONFIG = {
  VERSION: '1.0.0',
  PREFIX: 'permissions_cache',
  DEFAULT_TTL: 30 * 24 * 60 * 60 * 1000, // 30 days
  ADMIN_TTL: 30 * 24 * 60 * 60 * 1000, // 30 days (same as default now)
} as const;

/**
 * Structured cache data with metadata
 */
export interface CacheEntry {
  permissions: PermissionsState;
  expiresAt: number;
  version: string;
  createdAt: number;
  userId: string;
}
